module.exports = __webpack_public_path__ + "img/ic-time-green.7b19bf84.svg";